import styled from "styled-components";
import PretendardText from "../../../../component/atoms/text/pretendardText";
import { useQuery } from "@tanstack/react-query";
import ReviewApi from "../../../../api/review.api";
import { fileUrl } from "../../../../api/api";
import { errorHandler } from "../../../../util/errorHandler";
import { minToMs } from "../../../../util/formatMs";
import Loading from "../../../../component/templates/Loading";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Pagination from "../../../../component/molecules/pagination";
import { useMemo, useState } from "react";
import { route } from "../../../../router/route";
import Empty from "../../../../component/molecules/empty";
import Pagination2 from "../../../../component/molecules/pagination2";
import { useEffect } from "react";

const ReviewList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  let { id } = useParams();

  const [currentPage, setCurrentPage] = useState(1);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  const [reviewList, setReviewList] = useState([]);

  const getReviewList = async () => {
    const data = {
      page: Number(currentPage),
      size: Number(pagination.size),
      memberId: id,
    };

    const response = (await ReviewApi.getListReview(data)).data.data;

    setPagination({
      ...pagination,
      totalCount: response.totalCount,
      totalPages: Math.ceil(response.totalCount / pagination.size),
    });

    const processedData = response.content.map((item, index) => {
      return {
        ...item,
        imageIsValid: true,
      };
    });

    const processedDataWithImages = await Promise.all(
      processedData.map(
        (item) =>
          new Promise((resolve) => {
            if (item.merchThumbnailServerFileName) {
              const img = new Image();
              img.src = `${fileUrl}/${item.merchThumbnailServerFileName}`;

              img.onload = () => {
                resolve({ ...item, imageIsValid: true });
              };

              img.onerror = () => {
                resolve({ ...item, imageIsValid: false });
              };
            } else {
              resolve(item);
            }
          })
      )
    );

    setReviewList(processedDataWithImages);
  };

  useEffect(() => {
    getReviewList();
  }, [currentPage]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <ReactionContainer>
          <ReactionHeader>
            <PretendardText
              style={{
                color: "#f3f3f3",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "28px",
                letterSpacing: "-0.3%",
              }}
            >
              상품 후기
            </PretendardText>
          </ReactionHeader>
          <div
            style={{
              width: "100%",
              height: "fit-content",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {reviewList.map((item, index) => {
              return (
                <div
                  key={index}
                  style={{
                    width: "100%",
                    height: 85,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0px 16px",
                    borderBottom:
                      index === 5
                        ? "none"
                        : "0.5px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  {item.merchThumbnailServerFileName && item.imageIsValid ? (
                    <img
                      src={
                        item?.merchThumbnailServerFileName
                          ? `${fileUrl}/${item?.merchThumbnailServerFileName}`
                          : ""
                      }
                      alt="상품 이미지"
                      style={{
                        width: 48,
                        height: 48,
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        backgroundColor: "#333",
                      }}
                    />
                  )}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 3,
                    }}
                  >
                    <PretendardText
                      className="truncate"
                      style={{
                        width: 400,
                        color: "#aaa",
                        fontSize: "15px",
                        fontWeight: 400,
                        lineHeight: "24.75px",
                      }}
                    >
                      {item?.content || ""}
                    </PretendardText>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          marginRight: 8,
                        }}
                      >
                        {/* item.score의 0점부터 5점에 따라 이미지 설정정 */}
                        {[...Array(5)].map((_, index) => (
                          <img
                            key={index}
                            src={
                              index < item?.score
                                ? "/assets/admin/icons/ico_star_fill.svg"
                                : "/assets/admin/icons/ico_star.svg"
                            }
                            alt="별점"
                          />
                        ))}
                      </div>
                      <PretendardText
                        style={{
                          color: "rgba(181, 181, 181, 0.5)",
                          fontSize: "14px",
                          fontWeight: 600,
                          lineHeight: "22.75px",
                          marginRight: 12,
                        }}
                      >
                        {item?.score || 0}.0
                      </PretendardText>
                      <PretendardText
                        className="truncate"
                        style={{
                          width: 95,
                          color: "rgba(181, 181, 181, 0.5)",
                          fontSize: "13px",
                          fontWeight: 500,
                          lineHeight: "18.75px",
                        }}
                      >
                        {item?.member?.nickname || ""}
                      </PretendardText>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {reviewList.length > 0 ? null : (
            <Empty style={{ borderBottom: "none" }} />
          )}
        </ReactionContainer>

        {/* 페이지네이션 영역 */}
        <Pagination2
          style={{ width: 265, marginTop: 28 }}
          route={``}
          queryString={``}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={pagination.totalPages}
          rangeSize={pagination.rangeSize}
          first={pagination.first}
          last={pagination.last}
        />
      </div>
    </>
  );
};

export default ReviewList;

const ReactionContainer = styled.div.attrs((props) => {})`
  width: 495px;
  height: fit-content;
  min-height: 565px;
  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 12px;
  background: #272829;
  box-shadow: 2px 2px 15px 0px rgba(0, 0, 0, 0.12);
`;

const ReactionHeader = styled.div.attrs((props) => {})`
  width: 100%;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
`;
